import React, { useState,useEffect } from 'react';


const Proyectos = () => {
  const [filtro, setFiltro] = useState('Todos');
  const [isLoading, setIsLoading] = useState(true);
   const [datos, setDatos] = useState([]);

  setTimeout(() => {
    setIsLoading(false)
  }, 1300);


   useEffect(() => {
     const enviarDatos = async () => {
       try {
         const respuesta = await fetch(
           "https://disomex.onrender.com/api/obtener-imagen",
           {
             method: "POST",
             headers: {
               "Content-Type": "application/json",
             },
             body: JSON.stringify({}),
           }
         );
         // Manejar la respuesta
         const data = await respuesta.json();
         console.log(data);
   
         // Verifica si hay datos y asigna el array a 'datos'
         if (data.datos && Array.isArray(data.datos)) {
           setDatos(data.datos); // Ahora accedemos a 'data.datos'

         } else {
           console.error("La respuesta no contiene un array 'datos':", data);
         }
       } catch (error) {
         console.error("Error al enviar los datos:", error);
       }
     };
   
     enviarDatos();
   }, []);

   
  // Filtrar los datos dinámicamente según el filtro
  const datosFiltrados = datos.filter((item) =>
    filtro === 'Todos' || item.titulo.includes(filtro)
  );

  const [modalData, setModalData] = useState(null); // Estado para almacenar la imagen activa

  document.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    console.log("Se presionó Escape");
   setModalData(false)
    
  }
});

  // Función para abrir el modal
  const abrirModal = (item) => {
    setModalData(item); // Guarda los datos del elemento clicado
  };

  // Función para cerrar el modal
  const cerrarModal = () => {
    setModalData(null);
  };
  

  return (
    <div className='p-6'>
      {isLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center h-screen bg-gray-100 z-50">
          <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
          <p className="text-xl mt-4 text-gray-700">Cargando contenido...</p>
        </div>
      ) }
       {/* Filtros con resaltado del servicio seleccionado */}
       <div className="flex flex-col items-center justify-around text-lg font-semibold mb-6 sm:flex-row ">
        {['Todos', 'Desarrollo Software', 'Desarrollo Web', 'Diseño Grafico', 'Gestion De Eventos', 'Redes Sociales'].map((categoria) => (
          <p
            key={categoria}
            onClick={() => setFiltro(categoria)}
            className={`cursor-pointer ${filtro === categoria ? ' font-bold border-b-[3.5px] border-black' : 'text-black'}`}
          >
            {categoria}
          </p>
        ))}
      </div>

      <div className="flex flex-wrap justify-between p-6 px-0 mb-2 sm:px-12">
        {datosFiltrados.map((item) => (
          <div
            key={item.id}
            className="containers relative w-[450px] h-[250px] group mx-auto mb-6 sm:w-[400px] hover:cursor-pointer"
            onClick={() => abrirModal(item)}
          >
            <img
              src={`data:image/jpeg;base64,${item.imagen}`} // Mostrar la imagen usando Base64
              alt={item.titulo}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 flex flex-col justify-center items-center bg-black bg-opacity-50 text-white text-center p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <h1 className="text-xl font-bold">{item.titulo}</h1>
              <p className="text-sm">{item.descripcion}</p>
            </div>
          </div>
        ))}

{modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-[90%] max-h-[90%]">
            <button
              onClick={cerrarModal}
              className="absolute font-bold top-4 right-4 text-white text-3xl bg-black p-2 rounded-full sm:text-xl"
            >
              ✕
            </button>
            <img
              src={`data:image/jpeg;base64,${modalData.imagen}`} // Mostrar la imagen usando Base64}
              alt={modalData.titulo}
              className="w-full h-auto max-h-[70vh] object-contain"
            />
            <h1 className="text-xl font-bold text-center mt-4">
              {modalData.titulo}
            </h1>
            <p className="text-center mt-2">{modalData.descripcion}</p>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default Proyectos;
